import { linkedAppsApi, LinkTarget } from '../services/linkedAppsApi';
import type { WorkSiteDef } from '../types/workSites';

/**
 * 「업무 사이트 › 전체 현황」 카드 — 순서 · 이름 · 단축 버튼.
 * 순서가 곧 화면 순서. 단축 버튼 경로는 각 사이트 화면 주소(사이트가 바꾸면 여기도 고친다).
 */
export const WORK_SITES: WorkSiteDef[] = [
  {
    target: 'project',
    label: '프로젝트',
    shortcuts: [
      { label: '입찰 공고', path: '/bids' },
      { label: '사업 진행', path: '/projects' },
      { label: '일정·마감', path: '/schedules' },
      { label: '실적 아카이브', path: '/archive' },
    ],
  },
  {
    target: 'hire',
    label: '채용',
    shortcuts: [
      { label: '공고', path: '/admin?tab=campaigns' },
      { label: '지원자·면접', path: '/admin?tab=pipeline' },
    ],
  },
  {
    target: 'investment',
    label: '투자 관리',
    shortcuts: [
      { label: '자금원', path: '/vehicles' },
      { label: '투자처', path: '/companies' },
      { label: '정기보고', path: '/reports/periodic' },
      { label: '원장', path: '/ledger' },
    ],
  },
];

/**
 * 일회용 표(60초)를 받아 그 사이트를 새 탭으로 연다 — 다시 로그인하지 않는다.
 * 표를 받는 사이(await)에 창을 열면 팝업 차단에 걸리므로, 누른 순간 빈 탭을 먼저 연다.
 * 실패하면 Error 를 던진다(부른 쪽이 토스트로 알린다).
 */
export async function openWorkSite(target: LinkTarget, next?: string): Promise<void> {
  const tab = window.open('about:blank', '_blank');
  if (tab) tab.opener = null;
  try {
    const { url } = await linkedAppsApi.handoff(target, next);
    if (tab) tab.location.href = url;
    else window.location.href = url; // 팝업이 막혔으면 이 탭에서 이동
  } catch (e) {
    tab?.close();
    throw e;
  }
}
